import { FileIcon } from '../../atoms/FileIcon';
import { TextBlock } from '../../atoms';
import React from 'react';
import useStyles from './FileInProgressModal.styles';

interface IFileInProgressModalProps {
  open?: boolean;
}

export const FileInProgressModal: React.FC<IFileInProgressModalProps> = ({
  open,
}) => {
  const classes = useStyles();
  return (
    <>
      {open && (
        <div className={classes.root}>
          <div className={classes.iconContainer}>
            <FileIcon iconType="uploadIcon" />
          </div>
          <div className={classes.textContainer}>
            <TextBlock type="textErrorModalTB" text={'Uploading'} />
          </div>
        </div>
      )}
    </>
  );
};
